import React, { Component } from "react";
import { Container } from 'reactstrap';
import { inject, observer } from "mobx-react";
import BootstrapTable from 'react-bootstrap-table-next';
import { CollapseItemTableIndicator } from "../../comum/components/CollapseItemTableIndicator";
import ViewNotice from "./ViewNotice";

@inject("store")
@observer
export class TabelaNotices extends Component {

  constructor(props) {
    super(props)
  }

  expandRow = {
    renderer: notice => <ViewNotice notice={notice} />,
    expanded: [],
    showExpandColumn: true,
    expandByColumnOnly: true,
    expandHeaderColumnRenderer: () => "",
    expandColumnPosition: "right",
    expandByColumnOnly: true,
    onExpandAll: (isExpandAll, results, e) => e.PreventDefault(),
    expandColumnRenderer: ({ expanded }) => <CollapseItemTableIndicator expanded={expanded} />
  }

  render() {
    const { notices, columns } = this.props
    return (
      <Container fluid className="tabela-container">
        <BootstrapTable bootstrap4
          striped
          bordered={false}
          keyField='Id'
          data={notices}
          columns={columns}
          expandRow={this.expandRow}
          classes="tabela tabela-layout"
          defaultSorted={[
            {
              dataField: "PublishAt",
              order: "desc"
            }
          ]} />
      </Container>
    )
  }
}


// WEBPACK FOOTER //
// ./src/modules/notices/components/TabelaNotices.js